import { useToast } from "@sg-protect/components";
import { useRef, useState } from "react";

const COPIED_FEEDBACK_DURATION_MS = 1500;

export function useCopyToClipboard(
    errorMessage = "Failed to copy the link to clipboard. Please try copying it manually."
) {
    const toast = useToast();
    const timeoutRef = useRef<number>(undefined);
    const [isCopied, setIsCopied] = useState(false);

    async function copy(value: string): Promise<boolean> {
        try {
            await navigator.clipboard.writeText(value);
            setIsCopied(true);
            window.clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(() => setIsCopied(false), COPIED_FEEDBACK_DURATION_MS);

            return true;
        } catch {
            toast.error(errorMessage);

            return false;
        }
    }

    return { copy, isCopied };
}
